import React from "react";
import { useSubheader } from "../../../../_metronic/layout";
export const MonthlyLeaderBoard = () => {
    const suhbeader = useSubheader();
    suhbeader.setTitle("Monthly  Leaderboard");
    return (
        <div>
 
        </div>
    )
}